import { Router, RouterConfiguration } from 'aurelia-router';

export class CountriesRolesIndexScreen {
  router: Router;

  configureRouter(config: RouterConfiguration, router: Router) {
    config.map([
      { route: '', redirect: 'all' },
      { route: ['all', ':userUniqueId'], moduleId: 'screens/administration/countries-roles-list', name: 'admin-countries-roles-list', title: 'Countries Roles' },
      { route: ['transferUserRoles', 'transferUserRoles/:id'], moduleId: 'screens/administration/transfer-user-roles', name: 'admin-transfer-user-roles', activationStrategy: 'replace' }
    ]);

    this.router = router;
  }
}
